import { render } from "./AddBlock.vue?vue&type=template&id=d21317ea&scoped=true"
import script from "./AddBlock.vue?vue&type=script&lang=js"
export * from "./AddBlock.vue?vue&type=script&lang=js"

import "./AddBlock.vue?vue&type=style&index=0&id=d21317ea&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d21317ea"]])

export default __exports__